import React from "react";

import { Flex, FormLabel, Icon, Tooltip } from "@chakra-ui/react";
import { IoHelpCircle } from "react-icons/io5";

// Label de formulário com ícone de ajuda (hint) ao lado. O ícone é focável
// (tabIndex) para o hint também abrir por toque/teclado, não só por hover.
export default function LabelComHint({ htmlFor, hint, children }) {
  return (
    <Flex alignItems="center" gap="6px" mb="8px">
      <FormLabel
        m={0}
        color="#5F6377"
        fontWeight="500"
        fontSize="14px"
        lineHeight="19.6px"
        htmlFor={htmlFor}
      >
        {children}
      </FormLabel>
      <Tooltip
        label={hint}
        hasArrow
        fontSize="md"
        maxW="400px"
        textAlign="justify"
        placement="top"
      >
        <span
          className="hint-tooltip"
          tabIndex={0}
          aria-label={`Ajuda: ${children}`}
        >
          <Icon as={IoHelpCircle} color="#6B6C71" boxSize="18px" />
        </span>
      </Tooltip>
    </Flex>
  );
}
